// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");

function sizeClassName(size) {
  if (size === "Compact") {
    return "form-modal form-modal-compact";
  } else {
    return "form-modal form-modal-large";
  }
}

function FormModal(props) {
  var __size = props.size;
  var onClose = props.onClose;
  var size = __size !== undefined ? __size : "Compact";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h2", {
                                    children: props.title,
                                    className: "text-lg font-semibold text-darkcharcoal truncate pr-2"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-4 w-4",
                                          alt: "",
                                          src: Image$ReactHooksTemplate.closeIcon
                                        }),
                                    "aria-label": "Close",
                                    className: "flex-shrink-0 p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-pigmentblue",
                                    type: "button",
                                    onClick: (function (param) {
                                        Curry._1(onClose, undefined);
                                      })
                                  })
                            ],
                            className: "flex items-center justify-between gap-4 px-5 py-4 border-b border-gray-200 flex-shrink-0"
                          }),
                      JsxRuntime.jsx("div", {
                            children: props.children,
                            className: "flex flex-col flex-1 min-h-0"
                          })
                    ],
                    "aria-modal": true,
                    className: "bg-white rounded-xl shadow-xl border border-gray-200 pointer-events-auto flex flex-col overflow-hidden w-full " + sizeClassName(size),
                    role: "dialog",
                    onClick: (function (e) {
                        e.stopPropagation();
                      })
                  }),
              className: "fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-black bg-opacity-30",
              onClick: (function (e) {
                  if (Caml_obj.equal(e.target, e.currentTarget)) {
                    return Curry._1(onClose, undefined);
                  }
                  
                })
            });
}

var make = FormModal;

exports.sizeClassName = sizeClassName;
exports.make = make;
/* react/jsx-runtime Not a pure module */
